import { usePromotePanel, PROMOTE_STEPS } from "../context/PromotePanelContext";
import { PromoteStepHelpTrigger } from "./PromoteStepHelpTrigger";
import { MarketingTagSelector } from "./MarketingTagSelector";
import { ProblemContextButton } from "./ProblemContextDialog";
import { MarketingTagType } from "@/bryntum-lib/models/MarketingTag";

export const DescribeStep = () => {
  const { form, allTags, toggleTag, suggestedSolutionTagIds, linkedProblemTags } = usePromotePanel();
  const watchTags = form.watch("tags");
  const { errors } = form.formState;

  const operationalTags = allTags.filter((t) => t.type === MarketingTagType.SOLUTION);

  return (
    <div className="space-y-5">
      {/* Solution Tags */}
      <div>
        <MarketingTagSelector
          headerEnd={
            <PromoteStepHelpTrigger
              stepLabel={PROMOTE_STEPS[1].label}
              helpText={PROMOTE_STEPS[1].helpText}
            />
          }
          tags={operationalTags}
          selectedTagIds={watchTags ?? []}
          onToggle={toggleTag}
          suggestedTagIds={suggestedSolutionTagIds}
          required
          error={errors.tags?.message}
        />
      </div>

      {/* Problem Context */}
      <ProblemContextButton tags={linkedProblemTags} className="border-t border-border/40 pt-1" />
    </div>
  );
};
